import { useEffect, useReducer } from 'react';
import { useInterval } from '../useInterval';
const initialState = {
  dd: 0,
  hh: 0,
  mm: 0,
  ss: 0
};
export function useTimer(timestamp) {
  let {
    zeroFill = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const [timer, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (timestamp * 1000 <= Date.now()) {
      return;
    }
    const timeDate = new Date(timestamp * 1000 - Date.now());
    const aMinute = 6e4;
    const aHour = aMinute * 60;
    const aDay = aHour * 24;
    const timeState = {
      dd: Math.floor(timeDate / aDay),
      hh: Math.floor(timeDate % aDay / aHour),
      mm: Math.floor(timeDate % aHour / aMinute),
      ss: Math.floor(timeDate % aMinute / 1000)
    };
    dispatch({
      type: 'SET_TIME',
      timeState
    });
  }, [timestamp]);
  useInterval(() => {
    dispatch({
      type: 'DECREASE_SECOND'
    });
  }, 1000);
  return zeroFill ? normalize(timer) : timer;
}
function decreaseSecond(state) {
  let {
    dd,
    hh,
    mm,
    ss
  } = state;
  if (ss > 0) ss -= 1;else if (mm > 0) {
    ss = 59;
    mm -= 1;
  } else if (hh > 0) {
    ss = 59;
    mm = 59;
    hh -= 1;
  } else if (dd > 0) {
    ss = 59;
    mm = 59;
    hh = 23;
    dd -= 1;
  } else {
    return state;
  }
  return {
    dd,
    hh,
    mm,
    ss
  };
}
function reducer(state, action) {
  switch (action.type) {
    case 'SET_TIME':
      return action.timeState;
    case 'DECREASE_SECOND':
      return decreaseSecond(state);
  }
}
function normalize(state) {
  let {
    dd,
    hh,
    mm,
    ss
  } = state;
  hh = "".concat(hh < 10 ? '0' : '').concat(hh);
  mm = "".concat(mm < 10 ? '0' : '').concat(mm);
  ss = "".concat(ss < 10 ? '0' : '').concat(ss);
  return {
    dd,
    hh,
    mm,
    ss
  };
}